import React, { useState } from "react";
import toast from "react-hot-toast";
import { Button, Spinner } from "flowbite-react";

import useSize from "../../../../../Utils/useSize/useSize";
import Header from "./Header";
import Backend from "../../../../../Backend/Backend";

const backend = await new Backend().init();

export default function Sharing(props) {
  const admin = props.admin;
  const item = props.item;

  const max_sharing = admin.sharing;

  const windowSize = useSize();

  const [loading, setLoading] = useState(false);

  const [sharing, setSharing] = useState("");

  const [user_limit, setUserLimit] = useState(0);
  const [deposit_limit, setDepositLimit] = useState(0);
  const [deposit_limit_total, setDepositLimitTotal] = useState(0);

  const EditSharing = () => {
    if (sharing == "") {
      toast.error("Invalid Sharing");
    } else if (sharing > max_sharing) {
      toast.error(`Max Sharing ${max_sharing}% Allow`);
    } else {
      setLoading(true);
      let data = {
        server: localStorage.getItem("server"),
        id: localStorage.getItem("id"),
        username: localStorage.getItem("username"),
        token: localStorage.getItem("token"),
        user_id: item.id,
        user_limit:
          user_limit == 0 || user_limit == null ? item.user_limit : user_limit,
        deposit_limit:
          deposit_limit == 0 || deposit_limit == null
            ? item.deposit_limit
            : deposit_limit,
        deposit_limit_total:
          deposit_limit_total == 0 || deposit_limit_total == null
            ? item.deposit_limit_total
            : deposit_limit_total,
        sharing: sharing,
      };

      backend.edit_user_details(data).then((r) => {
        setLoading(false);
        if (r.error == "False") {
          toast.success(r.message);
          props.reload();
          props.close();
        } else {
          toast.error(r.message);
        }
      });
    }
  };

  return (
    <div
      className="background border primary-border"
      style={{
        width: windowSize[0] / 3,
        height: windowSize[1] / 3,
        borderRadius: 10,
      }}
    >
      <Header item={item} close={props.close} />

      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          flexDirection: "column",
        }}
      >
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            height: 70,
            marginBottom: 10,
            flexDirection: "column",
            marginTop: 20,
          }}
        >
          <div style={{ display: "flex" }}>
            <label for="sharing" class="label marginright bold flex">
              SHARING : {item.sharing}
            </label>
            <label for="sharing" class="label marginright bold">
              MAX : {max_sharing}
            </label>
          </div>
          <input
            type="number"
            name="sharing"
            id="sharing"
            role="presentation"
            autoComplete="new-password"
            style={{ width: windowSize[0] / 4, marginTop: 5 }}
            class="label input bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-600 dark:border-gray-500 dark:placeholder-gray-400 dark:text-white"
            placeholder="Enter Sharing"
            value={sharing}
            onChange={(e) => {
              if (e.target.value > max_sharing) {
              } else {
                setSharing(e.target.value);
              }
            }}
          />
        </div>

        <Button
          onClick={!loading ? EditSharing : null}
          className="w-full mt-2 max-w-sm text-white font-semibold !bg-[var(--primary)] hover:brightness-90 focus:ring-0 focus:outline-none transition-all rounded-lg flex items-center justify-center text-center"
        >
          <div className="flex items-center justify-center gap-2">
            {loading && <Spinner size="sm" />}
            {!loading && "UPDATE SHARING"}
          </div>
        </Button>
      </div>
    </div>
  );
}
